import * as React from 'react'
import { SVGProps } from 'react'
const SvgStarStroke = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.6503 9.04L14.8103 8.62L12.9203 4.17C12.5803 3.36 11.4203 3.36 11.0803 4.17L9.19032 8.63L4.36032 9.04C3.48032 9.11 3.12032 10.21 3.79032 10.79L7.46032 13.97L6.36032 18.69C6.16032 19.55 7.09032 20.23 7.85032 19.77L12.0003 17.27L16.1503 19.78C16.9103 20.24 17.8403 19.56 17.6403 18.7L16.5403 13.97L20.2103 10.79C20.8803 10.21 20.5303 9.11 19.6503 9.04ZM12.0003 15.4L8.24032 17.67L9.24032 13.39L5.92032 10.51L10.3003 10.13L12.0003 6.1L13.7103 10.14L18.0903 10.52L14.7703 13.4L15.7703 17.68L12.0003 15.4Z"
      fill="currentColor"
    />
  </svg>
)
export default SvgStarStroke
